/* eslint-disable react/no-find-dom-node */
import { findDOMNode } from 'slate-react';

const isInViewport = (distance, statusBarRef) => {
  // const distance = elem.getBoundingClientRect();
  // const focusDOMNode = findDOMNode(document);
  // const distance = focusDOMNode.getBoundingClientRect();
  const { current: statusBarRefCurrent } = statusBarRef;
  const { offsetHeight: statusBarHeight } = statusBarRefCurrent;
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <=
      (window.innerHeight - statusBarHeight ||
        document.documentElement.clientHeight) &&
    distance.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};
export default (node, statusBarRef, updatedDocument, nextBlock, props) => {
  if (window.env === 'test') return;
  setTimeout(() => {
    let nextNode;
    if (nextBlock) {
      nextNode = nextBlock;
    } else {
      nextNode = node && updatedDocument.getNextBlock(node.key);
    }
    const domNextNode = nextNode && findDOMNode(nextNode);
    const domNode = node && findDOMNode(node);
    const distanceNextNode = domNextNode && domNextNode.getBoundingClientRect();
    const distance = domNode && domNode.getBoundingClientRect();

    if (statusBarRef) {
      if (distanceNextNode && isInViewport(distanceNextNode, statusBarRef))
        return;
      const { current: statusBarRefCurrent } = statusBarRef;
      const { offsetTop: statusBarTop } = statusBarRefCurrent;

      const {
        userPreferences: {
          layout: { previewPad },
        },
      } = props;

      let editorContainer = document.querySelector('.editor-container');
      if (!previewPad) {
        editorContainer = document.querySelector('.editor-parent');
      }

      if (editorContainer && distanceNextNode && distance) {
        editorContainer.scrollBy({
          top:
            distanceNextNode.bottom -
            distance.bottom -
            (statusBarTop - distance.bottom) +
            distanceNextNode.top -
            distance.bottom +
            150,
          behavior: 'smooth',
        });
      }
    } else {
      domNode.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, 0);
};
